import { InjectionToken } from '@angular/core';
import { NzLocale } from './nz-locale.class';

export const NZ_LOCALE = new InjectionToken<NzLocale>('nz-locale');
